// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"92084c7f","230":"af694778","375":"a9fc00ba","403":"1c84b939","457":"02e579e3","629":"456088fd"}[chunkId] + ".chunk.js";
};